/* eslint-disable @typescript-eslint/indent */
import { cx, css } from '@linaria/core';
import { styled } from '@linaria/react';
import { flex, theming } from 'styles/utils';
import { SIDEBAR_SECTIONS_GAP } from '../../Sidebar.styles';
export const Divider = /*#__PURE__*/styled("div")({
  name: "Divider",
  class: "odules__Sidebar__components__Menu__Menu_styles_ts-Divider-d1x5dwvy"
});
export const menuStack = "odules__Sidebar__components__Menu__Menu_styles_ts-menuStack-mg5zttl";
export const menuGroup = cx("odules__Sidebar__components__Menu__Menu_styles_ts-menuGroup-m19ocvoi", flex.init, flex.direction.column);
export const line = "odules__Sidebar__components__Menu__Menu_styles_ts-line-lt8eo2x";
export const menuItemWrapper = "odules__Sidebar__components__Menu__Menu_styles_ts-menuItemWrapper-m13oms00";
export const tooltipTitle = "odules__Sidebar__components__Menu__Menu_styles_ts-tooltipTitle-t1jbkt5t";

require("./Menu.styles.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Menu.styles.ts");